import { Drawer, Stack } from "@mui/material";

export interface NavigationMenuDrawerMobileProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export function NavigationMenuDrawerMobile(props: NavigationMenuDrawerMobileProps) {
  const { open, onClose, children } = props;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: (theme) => ({
          width: "100%",
          background: theme.palette.navbar?.background,
          paddingTop: "var(--safe-area-inset-top)",
          paddingBottom: "var(--safe-area-inset-bottom)",
        }),
      }}
    >
      <Stack sx={{ px: 3, pt: 3, pb: 0, gap: 0, overflow: "hidden" }}>{children}</Stack>
    </Drawer>
  );
}
